// i18n dictionary for Belo Horizonte Residences landing page
export const translations = {
  pt: {
    nav: {
      about: "O Empreendimento",
      amenities: "Comodidades",
      gallery: "Galeria",
      typologies: "Tipologias",
      prices: "Preços",
      location: "Localização",
      contact: "Contacto",
      cta: "Fale com o consultor",
    },
    hero: {
      eyebrow: "Setúbal · Avenida Belo Horizonte",
      title: "Belo Horizonte",
      titleAccent: "Residences",
      subtitle:
        "Viver contemporâneo com vista para o rio Sado e a Serra da Arrábida. Onde a arquitetura moderna encontra a natureza.",
      ctaPrimary: "Agendar visita",
      ctaSecondary: "Ver tipologias",
      scroll: "Explorar",
    },
    about: {
      eyebrow: "Sobre o empreendimento",
      title: "Um refúgio moderno entre a Serra da Arrábida e o rio Sado.",
      body:
        "Belo Horizonte Residences é um condomínio residencial exclusivo que reúne design contemporâneo, vistas para o rio Sado e a Serra da Arrábida e o estilo de vida vibrante de Setúbal. Rodeado por jardins paisagísticos e espaços exteriores cuidadosamente desenhados, oferece a harmonia perfeita entre natureza, conforto e sofisticação.",
      stats: [
        { value: "3", label: "Blocos residenciais" },
        { value: "T0–T2", label: "Tipologias disponíveis" },
        { value: "30 min", label: "De Lisboa" },
        { value: "A+", label: "Eficiência energética" },
      ],
    },
    amenities: {
      eyebrow: "Condomínio privado estilo resort",
      title: "Tudo o que precisa, à distância de um passo.",
      items: [
        { t: "Segurança 24/7", d: "Guarda privado permanente." },
        { t: "Piscina e solários", d: "Zona de lazer com vista." },
        { t: "Ginásio interior", d: "Totalmente equipado." },
        { t: "Yoga & Pilates", d: "Sala dedicada a bem-estar." },
        { t: "Ginásio exterior", d: "Treinar ao ar livre." },
        { t: "Jardins paisagísticos", d: "Com esculturas modernas." },
        { t: "Snooker & Ping Pong", d: "Espaço de convívio." },
        { t: "Wine bar", d: "Para momentos únicos." },
        { t: "Coffee kitchen", d: "Café partilhado." },
        { t: "Lavandaria equipada", d: "Serviço completo." },
        { t: "Trilhos e zonas verdes", d: "Caminhar em paz." },
        { t: "Estacionamento privado", d: "Para cada apartamento." },
        { t: "30+ lugares de visitas", d: "Espaço para convidados." },
        { t: "Handyman exclusivo", d: "Pequenos reparos incluídos." },
        { t: "Limpeza 6 dias/semana", d: "Espaços comuns impecáveis." },
        { t: "Minibus privado", d: "5 rotas manhã + 5 tarde." },
      ],
    },
    gallery: {
      eyebrow: "Galeria",
      title: "Um olhar pelo projeto.",
      subtitle:
        "Renderings e ambientes que antecipam a experiência de morar em Belo Horizonte Residences.",
    },
    typologies: {
      eyebrow: "Plantas & Tipologias",
      title: "Espaços pensados ao detalhe.",
      subtitle:
        "Do estúdio compacto à suite de dois quartos — cada tipologia foi desenhada para maximizar luz natural e vistas.",
      common: {
        area: "Área útil",
        balcony: "Varanda",
        garage: "Garagem",
        from: "Desde",
      },
      items: [
        {
          code: "T0",
          name: "Estúdio / T0",
          area: "35 – 43,4 m²",
          balcony: "4 – 11,3 m²",
          garage: "13 m²",
          desc:
            "Estúdios luminosos com cozinha aberta, varanda e integração total dos espaços.",
          from: "€ 179.900",
        },
        {
          code: "T1",
          name: "Apartamento T1",
          area: "52 – 59,3 m²",
          balcony: "6,4 – 23,7 m²",
          garage: "13 m²",
          desc:
            "Um quarto, sala ampla e varandas generosas para prolongar o interior para o exterior.",
          from: "€ 265.000",
        },
        {
          code: "T2",
          name: "Apartamento T2",
          area: "72 – 84 m²",
          balcony: "6,4 – 23,7 m²",
          garage: "13 m²",
          desc:
            "Dois quartos, duas casas de banho e zonas sociais desenhadas para receber.",
          from: "€ 340.000",
        },
      ],
    },
    prices: {
      eyebrow: "Tabela de preços",
      title: "Encontre a sua fração.",
      subtitle:
        "Preços de lançamento por tempo limitado. Filtre por bloco e tipologia para descobrir a opção certa para si.",
      filters: {
        block: "Bloco",
        type: "Tipologia",
        availability: "Disponibilidade",
        all: "Todos",
        available: "Disponíveis",
        unavailable: "Indisponíveis",
        map: "Ver mapa dos blocos",
        mapTitle: "Localização dos blocos",
      },
      columns: {
        block: "Bloco",
        unit: "Fração",
        floor: "Piso",
        type: "Tipologia",
        area: "Área",
        balcony: "Varanda",
        terrace: "Terraço",
        total: "Total",
        launch: "Preço de lançamento",
        market: "P.V.P.",
      },
      consult: "Consultar",
      disclaimer:
        "Valores indicativos sujeitos a confirmação. Disponibilidade em tempo real junto do consultor.",
    },
    location: {
      eyebrow: "Localização",
      title: "Setúbal, uma cidade em ascensão.",
      body:
        "Perfeitamente posicionado na Avenida Belo Horizonte, a minutos das praias da Arrábida, do Parque Natural e com ligação direta a Lisboa, ao aeroporto e à Tróia.",
      distances: [
        { place: "Lisboa", time: "< 30 min" },
        { place: "Aeroporto de Lisboa", time: "35 min" },
        { place: "Hospital", time: "5 min" },
        { place: "Ferry Tróia", time: "5 min" },
        { place: "Estação de Setúbal", time: "6 min" },
        { place: "Universidade (IPS)", time: "7 min" },
        { place: "Outlet de Lisboa", time: "20 min" },
        { place: "Praia da Figueirinha", time: "12 min" },
      ],
    },
    agent: {
      eyebrow: "O seu consultor",
      title: "João Bernardo Lobo",
      role: "Consultor Imobiliário · Century 21 Portugal",
      body:
        "Acompanho-o em todo o processo — da primeira visita à escritura. Marque uma conversa e descubra a fração ideal para o seu investimento ou residência.",
      call: "Ligar",
      whatsapp: "WhatsApp",
      email: "Email",
      website: "Website",
    },
    footer: {
      rights: "Todos os direitos reservados.",
      disclaimer:
        "Cada agência é jurídica e financeiramente independente. AMI licenciada.",
    },
  },
  en: {
    nav: {
      about: "The Development",
      amenities: "Amenities",
      gallery: "Gallery",
      typologies: "Typologies",
      prices: "Pricing",
      location: "Location",
      contact: "Contact",
      cta: "Talk to the advisor",
    },
    hero: {
      eyebrow: "Setúbal · Avenida Belo Horizonte",
      title: "Belo Horizonte",
      titleAccent: "Residences",
      subtitle:
        "Contemporary living with views over the Sado river and the Arrábida mountains. Where modern architecture meets nature.",
      ctaPrimary: "Book a viewing",
      ctaSecondary: "See typologies",
      scroll: "Explore",
    },
    about: {
      eyebrow: "About the development",
      title: "A modern retreat between the Arrábida mountains and the Sado river.",
      body:
        "Belo Horizonte Residences is an exclusive residential community that brings together contemporary design, views over the Sado river and the Arrábida mountains and the vibrant lifestyle of Setúbal. Surrounded by landscaped gardens and carefully designed outdoor spaces, it offers the perfect harmony between nature, comfort and sophistication.",
      stats: [
        { value: "3", label: "Residential blocks" },
        { value: "T0–T2", label: "Unit types" },
        { value: "30 min", label: "From Lisbon" },
        { value: "A+", label: "Energy efficiency" },
      ],
    },
    amenities: {
      eyebrow: "Resort-style private condominium",
      title: "Everything you need, steps from home.",
      items: [
        { t: "24/7 Security", d: "Permanent private guard." },
        { t: "Pool & sunbeds", d: "Leisure area with a view." },
        { t: "Indoor gym", d: "Fully equipped." },
        { t: "Yoga & Pilates", d: "Dedicated wellness room." },
        { t: "Outdoor gym", d: "Train in the open air." },
        { t: "Landscaped gardens", d: "With modern sculptures." },
        { t: "Snooker & Ping Pong", d: "A social space." },
        { t: "Wine bar", d: "For memorable moments." },
        { t: "Coffee kitchen", d: "Shared café corner." },
        { t: "Equipped laundry", d: "Full service room." },
        { t: "Walking paths", d: "Green leisure areas." },
        { t: "Private parking", d: "For every apartment." },
        { t: "30+ guest spaces", d: "Room for visitors." },
        { t: "Exclusive handyman", d: "Small repairs included." },
        { t: "Cleaning 6 days/wk", d: "Spotless common areas." },
        { t: "Private minibus", d: "5 morning + 5 evening routes." },
      ],
    },
    gallery: {
      eyebrow: "Gallery",
      title: "A glimpse of the project.",
      subtitle:
        "Renderings and ambiences that anticipate the experience of living at Belo Horizonte Residences.",
    },
    typologies: {
      eyebrow: "Floor plans & Typologies",
      title: "Spaces designed to the detail.",
      subtitle:
        "From the compact studio to the two-bedroom suite — each typology is crafted to maximise natural light and views.",
      common: {
        area: "Interior area",
        balcony: "Balcony",
        garage: "Garage",
        from: "From",
      },
      items: [
        {
          code: "T0",
          name: "Studio / T0",
          area: "35 – 43.4 m²",
          balcony: "4 – 11.3 m²",
          garage: "13 m²",
          desc:
            "Bright studios with open kitchen, balcony and fully integrated living spaces.",
          from: "€ 179,900",
        },
        {
          code: "T1",
          name: "1-Bedroom",
          area: "52 – 59.3 m²",
          balcony: "6.4 – 23.7 m²",
          garage: "13 m²",
          desc:
            "One bedroom, spacious living and generous balconies extending the interior outside.",
          from: "€ 265,000",
        },
        {
          code: "T2",
          name: "2-Bedroom",
          area: "72 – 84 m²",
          balcony: "6.4 – 23.7 m²",
          garage: "13 m²",
          desc:
            "Two bedrooms, two bathrooms and generous social areas designed for hosting.",
          from: "€ 340,000",
        },
      ],
    },
    prices: {
      eyebrow: "Price list",
      title: "Find your unit.",
      subtitle:
        "Launch pricing available for a limited time. Filter by block and typology to discover the right option for you.",
      filters: {
        block: "Block",
        type: "Typology",
        availability: "Availability",
        all: "All",
        available: "Available",
        unavailable: "Unavailable",
        map: "View block map",
        mapTitle: "Block locations",
      },
      columns: {
        block: "Block",
        unit: "Unit",
        floor: "Floor",
        type: "Type",
        area: "Area",
        balcony: "Balcony",
        terrace: "Terrace",
        total: "Total",
        launch: "Launch price",
        market: "Market price",
      },
      consult: "Inquire",
      disclaimer:
        "Indicative values subject to confirmation. Live availability with the advisor.",
    },
    location: {
      eyebrow: "Location",
      title: "Setúbal, a city on the rise.",
      body:
        "Perfectly positioned on Avenida Belo Horizonte, minutes from the Arrábida beaches, the Natural Park and with direct connection to Lisbon, the airport and Tróia.",
      distances: [
        { place: "Lisbon", time: "< 30 min" },
        { place: "Lisbon Airport", time: "35 min" },
        { place: "Hospital", time: "5 min" },
        { place: "Tróia Ferry", time: "5 min" },
        { place: "Setúbal Station", time: "6 min" },
        { place: "University (IPS)", time: "7 min" },
        { place: "Lisbon Outlet", time: "20 min" },
        { place: "Figueirinha Beach", time: "12 min" },
      ],
    },
    agent: {
      eyebrow: "Your advisor",
      title: "João Bernardo Lobo",
      role: "Real Estate Advisor · Century 21 Portugal",
      body:
        "I'll guide you through every step — from the first viewing to the deed. Let's talk and find the perfect unit for your investment or home.",
      call: "Call",
      whatsapp: "WhatsApp",
      email: "Email",
      website: "Website",
    },
    footer: {
      rights: "All rights reserved.",
      disclaimer:
        "Each office is independently owned and operated. Licensed by AMI.",
    },
  },
};

export const AGENT = {
  name: "João Bernardo Lobo",
  phone: "+351916255051",
  phoneDisplay: "+351 916 255 051",
  email: "joaolobo@century21.pt",
  website: "https://joaolobo.century21.pt/",
  photo: "/assets/agent.png",
  whatsappMsg:
    "Olá João, gostaria de mais informações sobre o Belo Horizonte Residences.",
};

export const slugify = (raw) => String(raw ?? "").trim().toLowerCase();

export function resolveAgent(registry, slug) {
  const base = { ...AGENT };
  const entry = slug && registry?.agents?.[slug];
  if (!entry) return base;
  const clean = Object.fromEntries(
    Object.entries(entry).filter(([, v]) => v != null && v !== ""),
  );
  const merged = { ...base, ...clean };
  if (!clean.website) merged.website = `https://${slug}.century21.pt/`;
  return merged;
}
